import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// IMPORTANT - must precede the view route due to substring path match
export const dashboardEditRoute: InvariantJiraRoute = {
	name: 'dashboard-edit',
	path: '/jira/dashboards/:dashboardId(\\d+)/edit',
	query: ['maximized?'],
	exact: true,
};
